import { render, staticRenderFns } from "./shopMsg.vue?vue&type=template&id=860fed34&scoped=true&"
import script from "./shopMsg.vue?vue&type=script&lang=js&"
export * from "./shopMsg.vue?vue&type=script&lang=js&"
import style0 from "./shopMsg.vue?vue&type=style&index=0&id=860fed34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860fed34",
  null
  
)

export default component.exports